module.exports = __webpack_public_path__ + "media/acid_mist.4abdbb6f.webm";